var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0057373 32.2802C0.0057373 17.1952 0.0057373 9.65273 4.69203 4.96644C9.37832 0.280151 16.9208 0.280151 32.0057 0.280151H139.888C154.973 0.280151 162.516 0.280151 167.202 4.96644C171.888 9.65273 171.888 17.1952 171.888 32.2802V125.989C171.888 141.074 171.888 148.617 167.202 153.303C162.516 157.989 154.973 157.989 139.888 157.989H32.0057C16.9208 157.989 9.37832 157.989 4.69203 153.303C0.0057373 148.617 0.0057373 141.074 0.0057373 125.989V32.2802Z",
    fill: "#182025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0057373 32.2802C0.0057373 17.1952 0.0057373 9.65273 4.69203 4.96644C9.37832 0.280151 16.9208 0.280151 32.0057 0.280151H139.888C154.973 0.280151 162.516 0.280151 167.202 4.96644C171.888 9.65273 171.888 17.1952 171.888 32.2802V125.989C171.888 141.074 171.888 148.617 167.202 153.303C162.516 157.989 154.973 157.989 139.888 157.989H32.0057C16.9208 157.989 9.37832 157.989 4.69203 153.303C0.0057373 148.617 0.0057373 141.074 0.0057373 125.989V32.2802Z",
    fill: "url(#paint0_radial_7_692)",
    fillOpacity: 0.55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_692",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.3845 -7.73896) rotate(90) scale(45.4416 139.983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33F1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182026",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5be656ce75110b88da17d4f4ca37a1fb.svg";
export { ForwardRef as ReactComponent };